import { render, staticRenderFns } from "./AMQCsRes.vue?vue&type=template&id=6ba1074a&scoped=true&"
import script from "./AMQCsRes.vue?vue&type=script&lang=js&"
export * from "./AMQCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1074a",
  null
  
)

export default component.exports